import React from 'react';
import EntitySEOChecker from './EntitySEOChecker';

function App() {
  return <EntitySEOChecker />;
}

export default App;
